const _temp0 = require("../components/global/accordion-body.riot");
const _temp1 = require("../components/global/accordion-title.riot");
const _temp2 = require("../components/global/breadcrumb-item.riot");
const _temp3 = require("../components/global/breadcrumb.riot");
const _temp4 = require("../components/global/button-back.riot");
const _temp5 = require("../components/global/button-group.riot");
const _temp6 = require("../components/global/button-submit.riot");
const _temp7 = require("../components/global/combobox.riot");
const _temp8 = require("../components/global/commessa.riot");
const _temp9 = require("../components/global/commesse.riot");
const _temp10 = require("../components/global/css-switcher.riot");
const _temp11 = require("../components/global/generic-table.riot");
const _temp12 = require("../components/global/heading-page.riot");
const _temp13 = require("../components/global/input-file.riot");
const _temp14 = require("../components/global/input-text.riot");
const _temp15 = require("../components/global/item-nav.riot");
const _temp16 = require("../components/global/login.riot");
const _temp17 = require("../components/global/logout-button.riot");
const _temp18 = require("../components/global/main-navi.riot");
const _temp19 = require("../components/global/modal-delete.riot");
const _temp20 = require("../components/global/modal-error.riot");
const _temp21 = require("../components/global/modal-ore.riot");
const _temp22 = require("../components/global/modal-result.riot");
const _temp23 = require("../components/global/my-button.riot");
const _temp24 = require("../components/global/my-checkbox.riot");
const _temp25 = require("../components/global/my-footer.riot");
const _temp26 = require("../components/global/my-label.riot");
const _temp27 = require("../components/global/my-textarea.riot");
const _temp28 = require("../components/global/pagination.riot");
const _temp29 = require("../components/global/progress-bar.riot");
const _temp30 = require("../components/global/raw.riot");
const _temp31 = require("../components/global/tag-area.riot");
const _temp32 = require("../components/global/tag.riot");
const _temp33 = require("../components/global/task.riot");
const _temp34 = require("../components/global/tasks.riot");
module.exports = {
  "accordion-body": _temp0,
  "accordion-title": _temp1,
  "breadcrumb-item": _temp2,
  "breadcrumb": _temp3,
  "button-back": _temp4,
  "button-group": _temp5,
  "button-submit": _temp6,
  "combobox": _temp7,
  "commessa": _temp8,
  "commesse": _temp9,
  "css-switcher": _temp10,
  "generic-table": _temp11,
  "heading-page": _temp12,
  "input-file": _temp13,
  "input-text": _temp14,
  "item-nav": _temp15,
  "login": _temp16,
  "logout-button": _temp17,
  "main-navi": _temp18,
  "modal-delete": _temp19,
  "modal-error": _temp20,
  "modal-ore": _temp21,
  "modal-result": _temp22,
  "my-button": _temp23,
  "my-checkbox": _temp24,
  "my-footer": _temp25,
  "my-label": _temp26,
  "my-textarea": _temp27,
  "pagination": _temp28,
  "progress-bar": _temp29,
  "raw": _temp30,
  "tag-area": _temp31,
  "tag": _temp32,
  "task": _temp33,
  "tasks": _temp34
}